"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Form = _interopRequireDefault(require("../../Form"));
var _SearchBarInput = _interopRequireDefault(require("./SearchBarInput"));
var _SearchBarInput2 = require("./SearchBarInput/SearchBarInput.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var SearchBar = function SearchBar(_ref) {
  var onFilter = _ref.onFilter,
    onReset = _ref.onReset,
    onSearch = _ref.onSearch,
    onSearchSuccess = _ref.onSearchSuccess,
    onSearchError = _ref.onSearchError,
    decorativeSearchIcon = _ref.decorativeSearchIcon,
    initialValue = _ref.initialValue,
    placeholder = _ref.placeholder,
    size = _ref.size,
    trigger = _ref.trigger;
  return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
    handleSubmit: onSearch,
    onSubmitSuccess: onSearchSuccess,
    onSubmitError: onSearchError
  }, /*#__PURE__*/_react["default"].createElement(_SearchBarInput["default"], {
    onFilter: onFilter,
    onSearch: onSearch,
    onSearchSuccess: onSearchSuccess,
    onSearchError: onSearchError,
    onReset: onReset,
    decorativeSearchIcon: decorativeSearchIcon,
    initialValue: initialValue,
    placeholder: placeholder,
    size: size,
    trigger: trigger
  }));
};
SearchBar.propTypes = process.env.NODE_ENV !== "production" ? {
  onSearch: _propTypes["default"].func.isRequired,
  onSearchSuccess: _propTypes["default"].func,
  onSearchError: _propTypes["default"].func,
  onReset: _propTypes["default"].func,
  onFilter: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  initialValue: _propTypes["default"].string,
  decorativeSearchIcon: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(Object.values(_SearchBarInput2.Size)),
  trigger: _propTypes["default"].oneOf(Object.values(_SearchBarInput2.Trigger))
} : {};
SearchBar.defaultProps = {
  onSearchSuccess: function onSearchSuccess() {
    return null;
  },
  onSearchError: function onSearchError() {
    return null;
  },
  onReset: function onReset() {
    return null;
  },
  onFilter: null,
  placeholder: '',
  initialValue: '',
  decorativeSearchIcon: false,
  size: _SearchBarInput2.Size.DEFAULT,
  trigger: _SearchBarInput2.Trigger.ON_SUBMIT
};
var _default = exports["default"] = SearchBar;